<div [className]="'loader' + (useOverlayLoader ? '  loader--overlay' : '') + (minimal ? '  loader--minimal' : '')">
    <div class="spinner-border  loader__spinner" role="status">
        <span class="sr-only" i18n>Loading...</span>
    </div>
</div>
